import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import RouteLoadingScreen from './RouteLoadingScreen';

/**
 * Auth pages (login/signup): if the user already has a session, send them to
 * the app instead of asking them to sign in again.
 */
const GuestOnlyRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <RouteLoadingScreen />;
  }

  return isAuthenticated ? <Navigate to="/home" replace /> : children;
};

export default GuestOnlyRoute;
